import { defaultDateDisplay } from "App/utils/helpers";

const PrepareDataExport = (datas, headers) => {
  if (datas.length > 0) {
    let data = [];
    datas?.map((item, i) => {
      let key = { no: i + 1 };
      Object.entries(headers).map((header) => {
        const newKey = header[1].replace(":date", "");
        const isDate = header[1].match(":date");
        let value = item[header[0]];
        if (isDate) {
          value = defaultDateDisplay(item[header[0]]);
        }

        return (key = { ...key, [newKey]: value });
      });
      return data.push(key);
    });
    return data;
  } else {
    return [];
  }
};

const PrepareDataExportAdvenced = (dataFrom, dataTo) => {
  let data = [];

  dataFrom.map((item, i) => {
    let key = {};
    Object.entries(dataTo).map((header) => {
      const newKey = header[1].key;

      let value = "";
      if (typeof header[1].value === "function") {
        value = header[1].value(item, i);
      } else {
        value = item[header[1].value];
      }

      return (key = { ...key, [newKey]: value });
    });
    return data.push(key);
  });

  return data;
};

const camelCase = (str) => {
  const hasil = str.substring(0, 1).toUpperCase() + str.substring(1);
  return hasil.replace("_", " ");
};

const FilterColumns = (data) => {
  // Get column names
  if (data.length > 0) {
    const columns = Object.keys(data[0]);
    let headers = [];
    columns.forEach((col, idx) => {
      headers.push({ label: camelCase(col), key: col });
    });

    return headers;
  } else {
    return [];
  }
};

export { PrepareDataExport, FilterColumns, PrepareDataExportAdvenced };
